/**
 * User Role Hook
 * P1 Fix: Now uses cached UserRoleContext instead of fetching on every mount
 */

import { useUserRoleContext, type UserRole } from "@/contexts/UserRoleContext";

export type { UserRole };
export type { UserRoleInfo } from "@/contexts/UserRoleContext";

export const useUserRole = () => {
  return useUserRoleContext();
};
